import { isEmpty } from 'lodash';

const objectFilters = ['author', 'assignees', 'constructions', 'customers', 'type', 'status'];

export const getObjectFilter = (filters) => {
  const res = filters;
  objectFilters.forEach((key) => {
    if (!isEmpty(filters[key])) {
      res[key] = filters[key].map((x) => ({ id: x }));
    }
  });
  return res;
};
